"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const StarFavIcon = (props) => {
    const { width, height, color, filled } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 20 19" },
        react_1.default.createElement(react_native_svg_1.G, { id: "illustarations-and-Icons", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
            react_1.default.createElement(react_native_svg_1.G, { id: "Icons", transform: "scale(0.55) translate(-2, -2)" },
                react_1.default.createElement(react_native_svg_1.G, { id: "atom-/-icon-/-line-/-custom-/-star" },
                    react_1.default.createElement(react_native_svg_1.Path, { d: "M14.485,12.41 L5.49448839,13.7154001 L5.3048612,13.7536172 C4.07894959,14.0724144 3.62870893,15.6399111 4.57079944,16.5582224 L11.075,22.9 L9.54054068,31.8535131 L9.51882709,32.0370425 C9.43651108,33.305938 10.7916553,34.2240729 11.9587898,33.610474 L20,29.385 L28.0412102,33.610474 L28.2090472,33.6878385 C29.3904015,34.1582359 30.6823622,33.1531365 30.4594593,31.8535131 L28.9233333,22.9 L35.4292006,16.5582224 L35.5601487,16.415844 C36.3645478,15.4373589 35.8074487,13.9045826 34.5055116,13.7154001 L25.5133333,12.41 L21.4945601,4.26239048 C20.883204,3.02364762 19.116796,3.02364762 18.5054399,4.26239048 L14.485,12.41 Z", id: "Star", fill: color, fillOpacity: filled ? 1 : 0, strokeWidth: 2, stroke: color }))))));
};
StarFavIcon.defaultProps = {
    color: 'currentColor',
    filled: false,
    width: 20,
    height: 19,
};
exports.default = react_1.default.memo(StarFavIcon);
